import { BLEND_MODES } from 'pixi.js';
import { Sequence } from '../../../core/displayobject/Sequence';
import { Helper } from '../../../core/utils/Helper';
import { Beheaded } from '../../Beheaded';
import { gsap } from 'gsap';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class TzantzaFlag extends PIXI.Container {
    private _timeline: gsap.core.Timeline;

    private flagBG: PIXI.Sprite; // backgroundAssets/scatter_indicator
    private Indicators: PIXI.Sprite[]; // backgroundAssets/scatter_signactive
    private DeIndicators: PIXI.Sprite[]; // backgroundAssets/scatter_signdiactive

    private isEnabled: boolean = true;

    constructor() {
        super();
        this.Init();
    }

    Init(): void {
        this.flagBG = this.addChild(new PIXI.Sprite(Beheaded.assetLoader.getTextures('backgroundAssets/scatter_indicator')[0]));
        this.flagBG.anchor.set(0.5);

        const posToApply: PIXI.Point[] = [new PIXI.Point(8, -40), new PIXI.Point(-25, -28), new PIXI.Point()];

        this.Indicators = [];
        this.DeIndicators = [];
        for (let i = 0; i < 3; i++) {
            const spD = this.addChild(
                new PIXI.Sprite(Beheaded.assetLoader.getTextures('backgroundAssets/scatter_signdiactive')[0])
            );
            const sp = this.addChild(
                new PIXI.Sprite(Beheaded.assetLoader.getTextures('backgroundAssets/scatter_signactive')[0])
            );
            sp.anchor.set(0.5);
            spD.anchor.set(0.5);
            sp.position = spD.position = posToApply[i];

            sp.alpha = 0;
            this.Indicators.push(sp);
            this.DeIndicators.push(spD);
        }
    }

    showFlag(val: boolean) {
        if (this.isEnabled == val) return;

        gsap.to(this, { alpha: val ? 1 : 0, duration: 0.25 });

        if (val) {
            this.Indicators.forEach((sp) => {
                gsap.to(sp, { alpha: 0, duration: 0.5 });
            });
        }
        this.isEnabled = val;
    }

    showAmm(amm: number): void {
        if (!this.isEnabled) return;
        this._timeline = Helper.setTimeline();

        amm > 2 && Beheaded.soundPlayer.playSound(SoundConfig.SCATTER_LAND_FALL);

        for (let k = 0; k < Math.min(amm, this.Indicators.length); k++) {
            this._timeline.to(this.Indicators[k], { alpha: 1, duration: 0.15 });

            const item = Beheaded.overlayAnim.playStandAloneSequence(
                Beheaded.assetLoader.getTextures('indicator_swosh'),
                {},
                this
            ).item as Sequence;
            item.position = this.Indicators[k].position;
            item.blendMode = BLEND_MODES.ADD;
            item.scale.set(0.6, 0.6);
        }
    }

    hideAll() {
        if (!this.isEnabled) return;
        this._timeline = Helper.setTimeline(this._timeline, undefined, true);

        this.Indicators.forEach((sp) => {
            this._timeline.to(sp, { alpha: 0, duration: 0.5 });
        });
    }
}
